import { useContext, useEffect, useState, useRef } from 'react';
import { Badge, Container, Dropdown, Form, FormControl, Nav, Navbar } from 'react-bootstrap';
import { FaBell } from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import AppContext from '../../../context/AppContext';
import echo from '../../../echo';
import '../../../assets/css/Admin/general/AdminHeader.css';
import logo from "../../../assets/images/TrustiDrivelogo.png";

const AdminHeader = () => {
  const navigate = useNavigate();
  const { baseUrl, authToken } = useContext(AppContext);

  const [notifications, setNotifications] = useState([]);
  const isFirstCleanup = useRef(true);

  const viewAllNotification = () => {
    axios
      .get(`${baseUrl}/admin/Notification/viewAllNotification`, {
        headers: { Authorization: `Bearer ${authToken}` },
      })
      .then((response) => {
        if (response.data.success === true) {
          setNotifications(response.data.notifications);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    viewAllNotification();
  }, []);

  // Real-time listener
  useEffect(() => {
    const channel = echo.channel('admin-notifications');

    channel.listen('.new-notification', (data) => {
      console.log("New real-time notification:", data);
      setNotifications((prev) => [data.notification, ...prev]);

      const audio = new Audio('/notification-sound.mp3');
      audio.play().catch((err) => console.log("Sound play error:", err));
    });

    return () => {
      if (isFirstCleanup.current) {
        isFirstCleanup.current = false;
        return;
      }
      echo.leaveChannel('admin-notifications');
    };
  }, []);

  const unreadCount = notifications.filter((n) => !n.is_read).length;
  const recentNotifications = notifications.slice(0, 3);

  return (
    <Navbar className="admin-header-navbar" expand="lg">
      <Container fluid>
        <div className="admin-header-navbar-left">
          <Navbar.Brand as={Link} to="/admin-dashboard" className="admin-header-logo">
            <img
              src={logo}
              alt="TrustiDrive"
              className="admin-header-logo-img"
            />
            <span className="admin-header-brand-name">Trustidrive</span>
          </Navbar.Brand>
        </div>

        <div className="admin-header-navbar-center">
          <Form className="admin-header-search-form">
            <div className="admin-header-search-wrapper">
              <FormControl
                type="search"
                placeholder="Search..."
                className="admin-header-search-input"
              />
            </div>
          </Form>
        </div>

        <div className="admin-header-navbar-right">
          <Nav>
            {/* Notifications */}
            <Dropdown align="end" className="admin-header-notification-dropdown">
              <Dropdown.Toggle variant="link" className="admin-header-notification-btn">
                <FaBell />
                {unreadCount > 0 && (
                  <Badge bg="danger" className="admin-header-notification-badge">{unreadCount}</Badge>
                )}
              </Dropdown.Toggle>
              <Dropdown.Menu className="admin-header-notification-menu">
                <Dropdown.Header>Notifications</Dropdown.Header>
                {recentNotifications.length === 0 && (
                  <Dropdown.Item disabled>No notifications yet</Dropdown.Item>
                )}
                {recentNotifications.map((item) => (
                  <Dropdown.Item key={item.id} onClick={() => navigate('/admin/notifications')}>
                    {item.title}
                  </Dropdown.Item>
                ))}
                <Dropdown.Divider />
                <Dropdown.Item className="text-center text-primary" onClick={() => navigate('/admin/notifications')}>
                  View All
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Nav>
        </div>
      </Container>
    </Navbar>
  );
};

export default AdminHeader;